import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import Tag from '../../components/lozenge/tags';
import { PopoverModelWrapper } from '../../components/modal/modal.styled';
import Heading from '../../components/typography';
import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn } from '../style/table.styled';

export const SystemUserHeader = ({
  actions,
  tableActions,
  hasMousePosition,
  resetMousePosition,
}: {
  actions: any;
  tableActions: any;
  hasMousePosition: boolean;
  resetMousePosition: () => void;
}): any => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    function handleClickOutside(event: any): void {
      if (!(event.target as HTMLElement).className.includes('roles-popovers')) {
        resetMousePosition();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [resetMousePosition]);

  const getActions = (rowData: Record<string, any>): any => {
    let newActions = [];
    if (rowData.status === 'Pending') {
      newActions = tableActions.filter(
        (item: any) =>
          item.action !== 'View Comments' &&
          item.action !== 'Resend Email' &&
          item?.action?.props?.children !== 'Deactivate' &&
          item?.action !== 'Activate'
      );
    } else if (rowData.status === 'Approved') {
      newActions = tableActions.filter(
        (item: any) =>
          ['Edit', 'View', 'Deactivate'].includes(item.action) ||
          ['Deactivate'].includes(item?.action?.props?.children)
      );
      if (rowData?.reSendEmail) {
        newActions = tableActions.filter(
          (item: any) =>
            ['Edit', 'View', 'Deactivate', 'Resend Email'].includes(item.action) ||
            ['Deactivate'].includes(item?.action?.props?.children)
        );
      }
    } else if (rowData.status === 'Rejected') {
      newActions = tableActions.filter((item: any) =>
        ['View Comments', 'Edit', 'View'].includes(item.action)
      );
    } else {
      newActions = tableActions;
    }

    // if (rowData.isDefaultAdmin === true) {
    //   newActions = tableActions.filter((item: any) => ['View'].includes(item.action));
    // }
    if (!isEmpty(rowData.isEnabled) || rowData.isEnabled === false) {
      newActions = tableActions.filter((item: any) =>
        ['View Comments', 'Edit', 'View', 'Activate'].includes(item.action)
      );
    }
    return newActions;
  };
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              // actions={tableActions}
              actions={getActions(row.original)}
              id={row.original.customerUserId}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
  // return [
  //   {
  //     Header: 'Employee Details',
  //     accessor: 'fullName',
  //     width: 300,
  //     Cell: ({ row }: any) => {
  //       return (
  //         <TableBodyCellColumn>
  //           <div className='cellTitle'>
  //             {(row.original.fullName as boolean) ? row.original.fullName : '-'}
  //           </div>
  //           <div className='cellSubtitle'>
  //             {(row.original.email as boolean) ? row.original.email : '-'}
  //           </div>
  //         </TableBodyCellColumn>
  //       );
  //     },
  //   },
  //   {
  //     Header: 'Department',
  //     accessor: 'customerDepartment',
  //     width: 200,
  //     Cell: ({ row }: any) => {
  //       return (
  //         <TableBodyCellColumn>
  //           {(row.original.customerDepartment as boolean) ? row.original.customerDepartment : '-'}
  //         </TableBodyCellColumn>
  //       );
  //     },
  //   },
  //   {
  //     Header: 'Job Title',
  //     accessor: 'customerTitle',
  //     width: 200,
  //     Cell: ({ row }: any) => {
  //       return (
  //         <TableBodyCellColumn>
  //           {(row.original.customerTitle as boolean) ? row.original.customerTitle : '-'}
  //         </TableBodyCellColumn>
  //       );
  //     },
  //   },
  //   {
  //     Header: 'System Role',
  //     accessor: 'customerRole',
  //     width: 200,
  //     Cell: ({ row }: any) => {
  //       return (
  //         <PopoverModelWrapper className='roles-popovers'>
  //           <Heading
  //             variant='body-s'
  //             title={(row.original.customerRole as boolean) ? row.original.customerRole : '-'}
  //             onClick={(e: any) => {
  //               setTitle(
  //                 `${String(
  //                   (row.original.customerRole as boolean) ? row.original.customerRole : ''
  //                 )}-${String(row.id ?? '')}`
  //               );
  //               handleShow(row.original.customerRoleId, e);
  //             }}
  //             className={`title roles-popovers ${
  //               hasMousePosition &&
  //               title === `${String(row.original.customerRole ?? '')}-${String(row.id ?? '')}`
  //                 ? 'active'
  //                 : ''
  //             }`}
  //           />
  //         </PopoverModelWrapper>
  //       );
  //     },
  //   },
  //   {
  //     Header: 'User Status',
  //     accessor: 'isEnabled',
  //     width: 200,
  //     Cell: ({ row }: any) => (
  //       <div className='cellTitle'>
  //         {(row.original.isEnabled as boolean) ? (
  //           <Tag variant={'info'} title={'Active'} />
  //         ) : row.original.isEnabled === false ? (
  //           <Tag variant={'error'} title={'Deactivated'} />
  //         ) : (
  //           '-'
  //         )}
  //       </div>
  //     ),
  //   },
  //   {
  //     Header: 'Status',
  //     accessor: 'statusId',
  //     width: 200,
  //     Cell: ({ row }: any) => (
  //       <Tag
  //         variant={
  //           row.original.status === 'Approved'
  //             ? 'success'
  //             : row.original.status === 'Rejected'
  //             ? 'error'
  //             : 'info'
  //         }
  //         title={(row.original.status as boolean) ? row.original.status : '-'}
  //       />
  //     ),
  //   },
  //   {
  //     Header: '',
  //     accessor: 'actions',
  //     width: 20,
  //     sortable: false,
  //     Cell: ({ row }: any) => (
  //       <ActionButton
  //         actions={getActions(row.original)}
  //         id={row.original.customerUserId}
  //         rowData={row.original}
  //         counter={parseInt(row?.id)}
  //       />
  //     ),
  //   },
  // ];
};
